module.exports = __webpack_public_path__ + "testimonial-header.94fc1db5f444e82b6242.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/assets/images/testimonial-header.png
// module id = ../../../../../src/assets/images/testimonial-header.png
// module chunks = main